export function csvToJson(csv, separator = ',') {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(separator);
  if (headers.length === 1) {
    headers = lines[0].split(',')
    separator = ","
  }
  headers = headers.filter((elem: string) => (elem.length !== 0 && elem !== '\r'))

  for (var i = 1; i < lines.length; i++) {
    var obj: any = {};
    var currentline = lines[i].split(separator);
    for (var j = 0; j < headers.length; j++) {
      if (currentline[j]) {
        obj[headers[j].replaceAll("/r", "").trim()] = currentline[j]?.replace("/r", "").trim();
      }
    }
    result.push(obj);
  }
  let list = result?.filter((elem) => (Object?.keys(elem)?.length !== 0))
  return JSON.stringify(list);
}
